module.exports = {
	"articleTitle1": "Schlissel approves process for renaming University buildings ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Mason Hall",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/classes-canceled-mason-weiser-and-hatcher-library-due-power-outage",
	"articleSnippet1": "Jan 23, 2017 ... Mason Hall, named after Michigan's first governor Stevens T. Mason, is one of \nmany campus buildings named in honor of a historic individual.",
	"articleSnippet2": "Sep 9, 2016 ... Classes were cancelled this morning due to a power outage on central campus \naffecting classes in Angell Hall, Mason Hall, Tisch Hall, Haven ...",
	"totalMisc": 0,
	"articleTitle2": "UPDATE: Friday classes canceled in Central Campus buildings due ...",
	"address": "435 S. State Street, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170307/kky.NEW_.CSGElection.3.7.17.033.jpg?itok=BoUMEoRu",
			"author": "Kelly Yu",
			"caption": "Nicholas Fadanelli and Ryan Gillcrist launch their campaign for respective president and vice president positions for LSA Student Government in Mason Hall on Tuesday."
		}
	],
	"position": {
		"lat": 42.276971,
		"lng": -83.739284
	},
	"tips": [
		{
			"text": "To remember what halls are in the building: MATH stands for Mason, Angell, Tisch, and Haven.",
			"person": "Ashley Zhang"
		}
	],
	"bathroomrating": [
		{
			"rating": 1,
			"bathroom": "Ladies bathroom near the elevator"
		},
		{
			"rating": 4,
			"bathroom": "3rd floor Mason Hall"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/masonhall.json
// module id = 916
// module chunks = 0